import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["detailsModal"];

  connect() {

  }

  openDetailsModal() {
    console.log("OK");
    this.detailsModalTarget.classList.remove("hidden");
  }


}